var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49632 16.0007C8.49632 14.4153 8.93312 12.9301 9.69197 11.6585V6.26437H4.29787C2.15699 9.0448 0.996521 12.4334 0.996521 16.0007C0.996521 19.568 2.15699 22.9565 4.29787 25.737H9.69197V20.3429C8.93312 19.0712 8.49632 17.5861 8.49632 16.0007Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9961 24.5004L13.2462 28.2503L16.9961 32.0002C20.5634 32.0002 23.952 30.8397 26.7324 28.6988V23.3105H21.344C20.0613 24.0721 18.5699 24.5004 16.9961 24.5004Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69177 20.3427L4.29767 25.7368C4.72153 26.2872 5.18308 26.8144 5.68251 27.3139C8.70442 30.3358 12.7223 32 16.9959 32V24.5002C13.8945 24.5002 11.1762 22.8303 9.69177 20.3427Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9957 16.0004C32.9957 15.027 32.9075 14.0517 32.7337 13.1019L32.593 12.3332H16.9961V19.833H24.5866C23.8495 21.2993 22.7162 22.4956 21.344 23.3103L26.7323 28.6987C27.2828 28.2748 27.81 27.8132 28.3095 27.3138C31.3314 24.2918 32.9957 20.274 32.9957 16.0004Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0064 9.99025L23.6692 10.6531L28.9724 5.35L28.3095 4.68715C25.2876 1.66523 21.2698 0.000961304 16.9961 0.000961304L13.2462 3.75086L16.9961 7.50076C19.2664 7.50076 21.4009 8.38486 23.0064 9.99025Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9963 7.50076V0.000961304C12.7226 0.000961304 8.70479 1.66523 5.68281 4.68708C5.18339 5.18651 4.72184 5.71368 4.29797 6.26423L9.69208 11.6583C11.1766 9.17071 13.8948 7.50076 16.9963 7.50076Z",
    fill: "#EB4132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9991,
    height: 31.9991,
    fill: "white",
    transform: "translate(0.996521 0.000961304)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1cd7680a.svg";
export { ForwardRef as ReactComponent };